import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "maint-banner",
  role: "alert"
}
const _hoisted_2 = { class: "maint-body" }
const _hoisted_3 = { class: "maint-msg" }
const _hoisted_4 = {
  key: 0,
  class: "maint-count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "maint-slide" }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.hasSidebar)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "maint-menu",
                    title: "Meniu (deschide/închide)",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "dx-icon dx-icon-menu" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "dx-icon dx-icon-warning maint-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message), 1),
                (_ctx.countdown)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Timp rămas: " + _toDisplayString(_ctx.countdown), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "maint-close",
                title: "Ascunde",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = false))
              }, "×")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}